import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { filter } from 'rxjs';
import { NavigationState } from './shared/enums/navigation-state.enum';
import { AuthService } from './shared/services/auth.service';
import { SupportChatService } from './shared/services/support-chat.service';
import { environment } from '../environments/environment';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss', './shared/components/app-loading-overlay/app-loading-overlay.component.scss'],
})
export class AppComponent implements OnInit {
  isLoggedIn = false;

  title = 'ng-guard';
  @ViewChild('closeModal') closeModal: ElementRef | undefined;
  navState!: NavigationState;
  userName!: string;
  clientName?: string;
  hideHeader: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    public supportChatService: SupportChatService
  ) {
  }

  ngOnInit(): void {


    this.addClarityScript(environment.clarityId);

    this.router.events.pipe(filter((e) => e.type == 1)).subscribe((e) => {
      this.hideHeader = this.router.url.includes('/view3d');
      this.updateNavState();

      this.isLoggedIn = this.isUserLoggedIn();
      if (this.isLoggedIn) {
        this.userName = this.authService.getUserName();
        this.clientName = this.authService.getClientName();
        this.supportChatService.init(this.clientName);
      }
    });
  }

  isUserLoggedIn() {
    return this.authService.isLoggedIn();
  }

  updateNavState() {
    this.navState = this.getNavState();
  }

  getNavState() {
    if (this.isUserLoggedIn()) return NavigationState.loggedIn;

    if (this.router.url === '/login') return NavigationState.logIn;

    return NavigationState.signUp;
  }

  disableDashBoard(): boolean {
    return !this.authService.isAdmin();
  }

  isAdminPage(): boolean {
    return this.router.url.indexOf('/admin') >= 0;
  }

  isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  isOffereePage(): boolean {
    return this.router.url.startsWith('/quotes/');
  }

  isOffersListPage(): boolean {
    // Remove query params for comparison
    const url = this.router.url.split('?')[0];
    // Offers-list page is /user/quotes
    return url === '/user/quotes';
  }

  getUserName(): string {
    return this.authService.getUserName();
  }

  goToDashBoard() {
    if (this.authService.isAdmin()) {
      this.router.navigate(['/admin']);
    } else if (this.authService.hasRoles('GENERAL_USER')) {
      this.router.navigate(['/user']);
    }
  }

  addClarityScript(clarityId: string) {
    if (!clarityId) return;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${clarityId}");
    `;
    document.head.appendChild(script);
  }


}
